import { useCallback } from 'react';
import type { MessageViewDataObject } from '#models/services';
import { useAddChatroomMessageToCache, useDeleteChatroomMessageInCache, useUpdateChatroomsCache } from '../../../cache';

export const useReplaceChatroomMessageInCache = () => {
  const addChatroomMessageToCache = useAddChatroomMessageToCache();
  const deleteChatroomMessageInCache = useDeleteChatroomMessageInCache();
  const updateChatroomsCache = useUpdateChatroomsCache();

  return useCallback(
    ({ message, messageIdToReplace }: { message: MessageViewDataObject; messageIdToReplace: string }) => {
      deleteChatroomMessageInCache({ chatroomId: message.chatroom, messageId: messageIdToReplace });
      addChatroomMessageToCache({ chatroomId: message.chatroom, message });
      updateChatroomsCache({ chatroomId: message.chatroom, newMessage: message });
    },
    [addChatroomMessageToCache, deleteChatroomMessageInCache, updateChatroomsCache],
  );
};
